import { useLocation } from "react-router-dom";
import ViewRecruitersDeal from "../../../components/admin/recruiters-deal";

const RecruitersDeal = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  return <ViewRecruitersDeal recruiterId={props?.match?.params?.id!} viewDeal={queryParams?.get('view-deal') || ''} />
}
export default RecruitersDeal